<template>
  <bk-page class="changePasswordPage" :loading="loading" pageType="navPage" :navBarInfo="navBarInfo">
		<bk-view class="view-form-main">
			<bk-form ref="bkForm" v-model="formData" :formConfig="formConfig" >
			</bk-form>
		</bk-view>

		<bk-view class="view-footer-main">
			<bk-button size="full" langCode="userInfo_personal_save" @click="handleSave"></bk-button>
		</bk-view>
	</bk-page>
</template>

<script>
	import { showToast } from 'vant';
	import { authReq } from '@/reqService';

	export default {
		name: 'changePassword',
		data (){
			return {
				loading: false,
				formData:{},
				userInfo:this.$bk_getUserInfo()
			};
		},
		computed:{
			navBarInfo (){
				return {
					langCode_title: 'userInfo_changePassword_title',
					backFlag: true,
				};
			},
			formConfig (){
				return {
					required:true,
					items:[
						{e:'input', type:'password', langCode:'userInfo_changePassword_password', key:'password' },
						{e:'input', type:'password', langCode:'userInfo_changePassword_confirmPassword', key:'newPassword' },
		
					]
				};
			}
		},
		methods:{
			// 处理提交参数
			getSubmitParams (){
				const params = {
					id:this.userInfo.userId,
					...this.formData, 
				};
			
				return params;
			},
		
			// 提交
			async handleSave (){

				if(!await this.$refs.bkForm.validator()){
					return false;
				}
				
				const params = this.getSubmitParams();

				if(params.password !== params.newPassword){
					showToast(this.$bk_lang['userInfo_changePassword_message_error']);
					return false;
				}

				this.loading = true;

				const {id, newPassword} = params;
				authReq.requestPostUserPasswordUpdate(this, {id, newPassword}).then(() => {
					this.loading = false;
					showToast(this.$bk_lang['userInfo_changePassword_editSuccess']);
					this.$emit('close');
				}).catch(() => {
					this.loading = false;
				});

			}
		}
		
	};
</script>

<style lang="less">
@import './changePassword.less';
</style>